function applyButtonFonts() {
  const selectors = [
    'button',
    'input[type="button"]',
    'input[type="submit"]',
    '.button',
    '.theme-button',
    '.accent',
    '.site-nav__link',
    '.site-nav__item > a'
  ];

  const elements = document.querySelectorAll(selectors.join(', '));
  elements.forEach(el => {
    el.style.setProperty('font-family', "'ANDRingo', sans-serif", 'important');
  });
}

document.addEventListener("DOMContentLoaded", applyButtonFonts);

const observer = new MutationObserver(applyButtonFonts);
observer.observe(document.body, { childList: true, subtree: true });
